import { RouteProps } from "react-router";


const routes = (): RouteProps[] =>
  require(`./forms`).default;
export default routes;
